<template>
    <div class="post-drawer" @click.self="close">
      
        <div class="drawer">
            <!-- <img src="./Group_169.png" style="height: 100vh;position: absolute;left: 0;transform: translateX(-100%);"> -->
            <div class="drawer-header">
                <div class="container-title">
                    <p class="title">{{ $t('dash.posts.drawer.preview') }}</p>

                    <Tooltip v-if="!isProcessing && !hasPendingMediaExport"
                        :active="event.originalStatus == 'failed' && event.originalPost.page.length && event.originalPost.page[0].post_number"
                        :text="event.originalPost.page.length && event.originalPost.page[0].post_number" 
                        position='bottom'
                    >
                        <div class="badge-status" :status="event.status" :class="event.status">
                            {{ $t(`dash.post.${event.status}`)}}

                            <template v-if="!['awaiting_approval','to_validate'].includes(event.status)">
                            • {{ new Date(event.date).toLocaleDateString($i18n.locale || 'fr-FR',{ weekday: 'long', day: 'numeric', month: 'short' }) }}
                            </template>
                        </div>
                    </Tooltip>
                    <Tooltip v-else
                        :active="true"
                        :text="$t('dash.posts.drawer.processing')"
                        position='bottom'
                    >
                        <div class="badge-status" :status="event.status" :class="event.status">
                            {{ $t(`dash.post.${event.status}`)}}
                            
                            <template v-if="!['awaiting_approval','to_validate'].includes(event.status)">
                            • {{ new Date(event.date).toLocaleDateString($i18n.locale || 'fr-FR',{ weekday: 'long', day: 'numeric', month: 'short' }) }} ⚠️
                            </template>
                            <template v-else>
                            • ⚠️
                            </template>
                        </div>
                    </Tooltip>
                 

                
                 
                </div>
                <div class="close">
                    <ContextMenu 
                        :options="optionsContextMenu" 
                        :id="'drawerMoreOption'" 
                        v-on:clickOption="clickOption"
                    >
                        <i class="fa-solid fa-ellipsis-vertical more"></i>
                    </ContextMenu>

                    <i class="fa-solid fa-xmark-large"  @click="close"></i>
                </div>
            </div>
            <div class="drawer-labels" v-if="!isPgDraft">
                <div
                    class="label-chip"
                    v-for="label in resolvedLabels"
                    :key="label.id"
                    :style="{ backgroundColor: label.color }"
                >
                    <i v-if="parsedLabelIcon(label.icon) && parsedLabelIcon(label.icon).type === 'fa'" class="fa-solid" :class="`fa-${parsedLabelIcon(label.icon).value}`"></i>
                    <span v-else-if="parsedLabelIcon(label.icon)" class="label-emoji">{{ parsedLabelIcon(label.icon).value }}</span>
                    <span>{{ label.name }}</span>
                </div>
                <div class="label-add" @click.stop="toggleLabelPicker">
                    <i class="fa-solid fa-plus"></i>
                    <span>{{ $t('dash.posts.labels.add-tooltip') }}</span>
                </div>
                <div v-if="labelPickerOpen" class="label-picker-backdrop" @click="closeLabelPicker"></div>
                <LabelPicker
                    v-if="labelPickerOpen"
                    class="label-picker-popover"
                    :selected="postLabelIds"
                    @update:selected="onLabelsUpdate"
                    @close="closeLabelPicker"
                />
            </div>
            <div v-if="isConvertedToV2 && ['scheduled', 'draft', 'standby'].includes(officialStatus)" class="drawer-v2-conversion-warning">
                <i class="fa-solid fa-triangle-exclamation"></i>
                {{ $t('dash.posts.drawer.converted-to-v2') }}
            </div>
            <div class="drawer-render" :class="event.draft && event.draft.tab" @mouseenter="expandedSectionNav = false">
                <div class="container-phone">
                    <div class="actions" v-if="!currentUser.role || currentUser.role.length !== 1 || currentUser.role[0] !== 'Viewer'">
                    <Tooltip
                        v-if="['scheduled', 'draft', 'standby', 'processing'].includes(this.officialStatus)"
                        :text="canUseActions ? $t('dash.posts.drawer.edit-post') : $t('dash.posts.drawer.wait')"
                        position='left'
                        @click="editPost"
                    >
                        <i class="fa-solid fa-pencil"></i>
                    </Tooltip>
                    <Tooltip 
                        v-else-if="
                            ['posted'].includes(this.officialStatus) && 
                            editableNetworks.includes(this.event.page.network) &&
                            this.event.draft.tab && 
                            this.event.draft.tab !== 'story' &&
                            !(this.event.page.network == 'linkedin' && haveUserMentions(event.originalPost.title))
                        " 
                        :text="canUseActions ? $t('dash.posts.drawer.update-post') : $t('dash.posts.drawer.wait')"
                        position='left'
                        @click="editPost"
                    >
                        <i class="fa-solid fa-pencil"></i>
                    </Tooltip>

                    
                    <Tooltip 
                        :text="canUseActions ? $t('dash.posts.drawer.duplicate-post') : $t('dash.posts.drawer.wait')"
                        position='left'
                        @click="duplicatePost"
                    >
                        <i class="fa-solid fa-clone"></i>
                    </Tooltip>

                    <Tooltip
                        :text="canUseActions ? $t('dash.button.delete.post') : $t('dash.posts.drawer.wait')"
                        position='left'
                        @click="deletePost"
                    >
                        <i class="fa-solid fa-trash-can"></i>
                    </Tooltip>


                    </div>
                    <Phone :showNotch="event.draft.tab == 'standard'" @click="()=>indexStorySelected = (indexStorySelected+1)%Object.keys(formData.storification).length">
                       
                        <template v-if="formData && Object.keys(formData).length">
                            <div v-if="event.type && event.type == 'story'" class="drawer-container-storyMaker">
                                <div class="nav-story" v-if="Object.keys(formData.storification).length > 1">
                                     <div class="bar" v-for="(key, index) in Object.keys(formData.storification)" :class="{active: indexStorySelected == index}"></div>
                                </div>

                                <StoryMakerFacebook
                                    v-if="isNativeFacebookStory"
                                    :formData="formData"
                                    :idStorySelected="Object.keys(formData.storification)[indexStorySelected]"
                                    :pageSelected="allPages[event.page.id]"
                                    :previewEnabled="true"
                                    :files="event.draft.files"
                                />
                                <StoryMaker
                                    v-else
                                    :formData="formData"
                                    :idStorySelected="Object.keys(formData.storification)[indexStorySelected]"
                                    :pageSelected="allPages[event.page.id]"
                                    :previewEnabled="true"
                                    :files="event.draft.files"
                                />
                            </div>
                            <RenderPostManager 
                                v-else
                                :typeNetworkSelected="event.page.network"
                                :formData="formData"
                                :files="event.draft.files"
                                :pages="[allPages[event.page.id]]"
                            /> 
                        </template>                  
                    </Phone>
                </div>
              
            </div>
            <div class="drawer-container-navigation" ref="scrollContainer">
                <div class="drawer-navigation" :class="{expanded: expandedSectionNav}">
                    <div class="tab" @click="expandedSectionNav = !expandedSectionNav">
                        <i class="fa-solid" :class="expandedSectionNav ? 'fa-caret-down' : 'fa-caret-up'"></i>
                        <!-- <svg width="100%" height="100%" viewBox="0 0 88 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.0883 0C8.04076 0 3.64095 3.43527 2.41674 8.33211L0.41674 16.3321C0.277115 16.8906 0.182703 17.4477 0.130859 18H85.5379C85.5021 17.6164 85.4458 17.2303 85.3683 16.8427L83.7683 8.84272C82.74 3.70106 78.2254 0 72.9819 0H13.0883Z" fill="white"/>
                        </svg> -->
                        <svg  width="100%" height="100%" viewBox="0 0 89 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.0872 2C10.0401 2 5.64066 5.43527 4.41655 10.3321L2.41672 18.3321C2.2771 18.8906 2.1827 19.4477 2.13086 20H87.5309C87.495 19.6164 87.4388 19.2303 87.3613 18.8427L85.7614 10.8427C84.7332 5.70106 80.219 2 74.9759 2H15.0872Z" fill="white"/>
                        </svg>

                    </div>

                    <div class="navigation">
                        <div class="item" @click="sectionNavSelected = 'comments'" :class="{active: sectionNavSelected == 'comments'}">{{ $t('dash.posts.drawer.tab.notes') }}</div>
                        <div class="item" @click="sectionNavSelected = 'assignments'" :class="{active: sectionNavSelected == 'assignments'}">{{ $t('dash.posts.drawer.tab.assignment') }}</div>
                        <div v-if="logs.length" class="item" @click="sectionNavSelected = 'logs'" :class="{active: sectionNavSelected == 'logs'}">{{ $t('dash.posts.drawer.tab.history') }}</div>
                        <div v-if="isPostedPost" class="item" @click="sectionNavSelected = 'reporting'" :class="{active: sectionNavSelected == 'reporting'}">{{ $t('dash.posts.drawer.tab.reporting') }}</div>
                    </div>

                    <DrawerComments
                        v-if="sectionNavSelected == 'comments'"
                        :comments="comments"
                        :currentUser="currentUser"
                        :expandedSectionNav="expandedSectionNav"
                        :event="event"
                        @comment-added="buildComment"
                    />
                    <DrawerAssignments
                        v-else-if="sectionNavSelected == 'assignments'"
                        :currentUser="currentUser"
                        :validationStatus="validationStatus"
                        :expandedSectionNav="expandedSectionNav"
                        :officialStatus="officialStatus"
                        :event="event"
                        @close="close"
                    />
                    <DrawerLogs
                        v-else-if="sectionNavSelected == 'logs'"
                        :logs="logs"
                        :expandedSectionNav="expandedSectionNav"
                    />

                    <DrawerReporting
                        v-else-if="sectionNavSelected == 'reporting'"
                        :event="event"
                        :expandedSectionNav="expandedSectionNav"
                    />
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import store from '@/store/index.js';
    import { EventBus } from '@/event-bus';
    import ContextMenu from '@/components/dash/contextMenu/contextMenuInit.vue'
    import Phone from "./../../../postCreator/components/Phone.vue"
    import RenderPostManager from '../../../postCreator/components/standardTab/RenderPostManager.vue'
    import StoryMaker from '../../../postCreator/components/storyTab/StoryMaker.vue'
    import StoryMakerFacebook from '../../../postCreator/components/storyTab/StoryMakerFacebook.vue'
    import postMixin from '@/components/mixins/Posts.vue'
    import draftMixin from '@/components/mixins/Drafts.vue'
    import labelsMixin from '@/components/mixins/Labels.vue'
    import postCreatorMixin from '../../../postCreator/mixins/main.js'
    import postsMixin from '@/components/dash/posts/mixins/main.js'
    import CommonMixin from '@/components/mixins/Common'
    import Popup from '@/utils/Popup'
    import Tooltip from '@/components/dash/tooltip/tooltipInit.vue'
    import LabelPicker from './components/LabelPicker.vue'


    import {
        mergeUpdates,
        deepClone,
        customModeIsAvailable,
    } from '../../../postCreator/utils.js'

    import DrawerComments from './components/DrawerComments/index.vue'
    import DrawerAssignments from './components/DrawerAssignments/index.vue'
    import DrawerLogs from './components/DrawerLogs/index.vue'
    import DrawerReporting from './components/DrawerReporting/index.vue'

    import { editableNetworks } from '@/components/dash/postCreator/constante.js'
    import { parseLabelIcon } from '@/utils/labelIcon.js'

    import * as marked from 'marked'

    export default {
        mixins: [postMixin, draftMixin, labelsMixin, postCreatorMixin, postsMixin, CommonMixin],

        components: {
            ContextMenu,
            Phone,
            RenderPostManager,
            StoryMaker,
            StoryMakerFacebook,
            Tooltip,
            LabelPicker,
            DrawerComments,
            DrawerAssignments,
            DrawerLogs,
            DrawerReporting
        },
        props: {
            event: Object,
        },

        data() {
            return {
            
                comments : [],
                sectionNavSelected: this.validationStatus !== null ? 'assignments' : 'comments',
                expandedSectionNav: false,
                loading : {
                    validation: false
                },

                //Pour generateDataFormRequest
                dataFormRequest: {},
                tab: null,
                saveAllFormData: null,
                formData: null,
                requiredValidation: false,
                logs: [],
                files: {},

                //storyMaker
                indexStorySelected: 0,

                editableNetworks,
                isRefreshingMusic: false,

                labelPickerOpen: false,
                labelPickerSnapshot: [],
            }
        },

        mounted () {

            if (this.$refs.scrollContainer) this.$refs.scrollContainer.addEventListener('wheel', this.handleScroll);
            this.sectionNavSelected = this.validationStatus !== null ? 'assignments' : 'comments';
            // Handled by watcher
            // this.setFormData()

            // Always refresh (not just when empty) — otherwise labels created/edited
            // since the store was first populated this session never show up here.
            this.$store.dispatch('labels/init')

            this.$gtag.event('page_view', {
                page_title: 'Test Page',
                page_location: window.location.href
            });
        },
        
        methods: {

            haveUserMentions(text) {
              let regexMentionsUser = /\(([0-9a-zA-Z_\-]{39})\)/g
              let mentionsUser = [...text.matchAll(regexMentionsUser)].map(e => e[1])
              return mentionsUser.length > 0
            },

            close(e) {
                e.stopPropagation();
                this.$emit('close')
            },

            async setFormData(formData, verifyDynamicUrl = true) {
                if (!formData) {
                    if (!this.event?.draft?.saveAllFormData) return null
                    formData = this.event.draft.saveAllFormData
                }

                const shouldUpdateForm = !this._musicVerifyInProgress || !verifyDynamicUrl;
                // Skip the stale-data form assignment if verification is already in progress
                // (a concurrent watcher trigger must not overwrite the result of setFormData(false))
                if (shouldUpdateForm) {
                    let formDataRef = deepClone(formData.main)

                    // Mirrors the guard in postCreator/mixins/main.js's send path: overrides
                    // only apply when the post still spans more than one page/network.
                    let availableNetworksForPersonalization = false
                    if (this.event.draft.tab !== 'story') {
                        const pagesSelected = this.event.originalStatus == 'draft' && this.event.draft.pages && this.event.draft.pages.length
                            ? this.event.draft.pages.map(id => this.allPages[id]).filter(Boolean)
                            : this.event.originalPost?.page?.[0]?.posts_multipages?.length
                                ? this.event.originalPost.page[0].posts_multipages.map(pm => this.allPages[pm.page]).filter(Boolean)
                                : [this.allPages[this.event.page.id]].filter(Boolean)

                        // Explicit validator (not formDataMain/files): this.files is always
                        // empty here, which would wrongly invalidate instagram/tiktok.
                        const networksInvolved = [...new Set(pagesSelected.map(p => p.network))]
                        const validator = Object.fromEntries(networksInvolved.map(n => [n, { isValid: true }]))
                        availableNetworksForPersonalization = customModeIsAvailable({ pagesSelected, validator })
                    }

                    if (['story_share','story'].includes(this.event.draft.tab) && this.event.page.network == 'facebook' && !this.isNativeFacebookStory) {
                        //repoduire la storification par rapport a la page instagram d'origine
                        if (formData.networks['instagram']) mergeUpdates(formDataRef, formData.networks['instagram'])
                        const pageInstagramAtached = Object.values(this.allPages).find(p => p.network == 'instagram' && p.affected_to && p.affected_to == this.allPages[this.event.page.id].network_id)
                        if (pageInstagramAtached && formData.pages[pageInstagramAtached.id]) mergeUpdates(formDataRef, formData.pages[pageInstagramAtached.id])
                    } else if (
                        ['story_share','story'].includes(this.event.draft.tab) ||
                        (availableNetworksForPersonalization && availableNetworksForPersonalization.includes(this.event.page.network))
                    ) {
                        if (formData.networks[this.event.page.network]) mergeUpdates(formDataRef, formData.networks[this.event.page.network])
                        if (formData.pages[this.event.page.id]) mergeUpdates(formDataRef, formData.pages[this.event.page.id])
                    }
                    this.formData = formDataRef
                }

                //mettre a jours les liens invalide
                if (verifyDynamicUrl) {
                    if (this._musicVerifyInProgress) {
                        return;
                    }
                    this._musicVerifyInProgress = true;
                    this.isRefreshingMusic = true;
                    const timeout = setTimeout(() => {
                        this.isRefreshingMusic = false;
                    }, 10000);
                    try {
                        let pageId = this.event.page.id;
                        if (this.event.page.network !== "instagram" || !this.allPages[pageId].story_config?.created) {
                            // Find the instagram page’s id
                            pageId = null;
                            if (this.event.originalPost?.page?.[0]?.posts_multipages) {
                                for (let pm of this.event.originalPost.page[0].posts_multipages) {
                                    const page = this.allPages[pm.page];
                                    if (page?.network === 'instagram' && page?.story_config?.created) {
                                        pageId = page.id;
                                        break;
                                    }
                                }
                            }
                            if (!pageId) {
                                // Try if in pageEmbed, in case of story share to FB
                                const fbPage = this.allPages[this.event.page.id];
                                const instaPage = Object.values(this.allPages).find((p) => p.affected_to === fbPage.network_id)
                                pageId = instaPage?.id;
                            }
                        }
                        if (pageId) {
                            const logContext = {
                                post_id: this.event.originalPost.id,
                                page_id: pageId,
                                originalStatus: this.event.originalStatus,
                            }
                            const { saveAllFormData, isModified, removedMusic } = await this.verifyDynamicUrlInstagram(this.event.draft.saveAllFormData, pageId);
                            if (isModified) {
                                this.addLog(this.currentUser, 'music-refresh-success', { logContext, draft: this.event.draft })
                                // The event.draft.saveAllFormData reference may have been replaced by a
                                // reactive store refresh during the async verification. Re-anchor it to
                                // the mutated object so duplicatePost/editPost commit the fresh data.
                                if (this.event.draft.saveAllFormData !== saveAllFormData) {
                                    this.event.draft.saveAllFormData = saveAllFormData
                                }
                                this.setFormData(saveAllFormData, false)
                            }
                            if (removedMusic && removedMusic.length) {
                                this.addLog(this.currentUser, 'music-removed', { logContext, tracks: removedMusic })
                                this.$vs.notify({
                                    title: this.$t('dash.post-creator.music.removed-title'),
                                    text: this.$t('dash.post-creator.music.removed-text', { tracks: removedMusic.join('", "') }),
                                    color: 'warning',
                                })
                            }
                        }
                    } finally {
                        clearTimeout(timeout);
                        this.isRefreshingMusic = false;
                        this._musicVerifyInProgress = false;
                    }
                }
            },

            editPost() {
                if (!this.canUseActions) return;
                let eventOldVersion = this.event.originalStatus == 'draft' &&
                    !this.event.originalPost.draft?.data?.saveAllFormData &&
                    !this.event.draft?.saveAllFormData
                if(eventOldVersion) {
                    const baseUrl = window.location.origin;
                    const paramsLink = {
                        post_id: this.event.originalPost.id,
                        page_id: this.event.page.id,
                        bot_id: this.event.originalPost._bots[0].id,
                        is_draft: this.officialStatus === 'draft',
                        edit_post: true,
                        no_redirection: true
                    };

                    this.$router.push({
                        path: '/dash/planner',
                        query: paramsLink // Ajout des paramètres dans la query string
                    });
                    return

                    const queryString = new URLSearchParams(paramsLink).toString();
                    window.location = `${baseUrl}/?${queryString}`;
                    return
                }

                switch (this.officialStatus){
                    case 'standby':
                        this.$store.commit('postCreator/setDataForDraft', {
                            data: this.event.draft,
                            id : this.event.originalPost.id
                        });
                        return this.duplicatePost(this.event.originalPost.id)
                    case 'processing':
                    case 'posted':
                    case 'scheduled':
                        let posts 
                        if (this.event.originalPost.page[0].posts_multipages && this.event.originalPost.page[0].posts_multipages.length) {
                            posts = this.event.originalPost.page[0].posts_multipages.filter(m => this.allPages[m.page])
                        }else{
                            posts = [{
                                _id: this.event.originalPost.id,
                                id: this.event.originalPost.id,
                                bot: this.event.originalPost._bots[0].id,
                                page: this.event.originalPost._bots[0].page.id,
                                postId: this.event.originalPost.page[0].post_number,
                                status: this.event.originalPost.status,
                            }]
                        }

                        this.$store.commit('postCreator/setDataForEditPost', {
                            draft: this.event.draft,
                            posts,
                            post: this.event.originalPost

                        });
                        if (['scheduled', 'processing'].includes(this.officialStatus)) this.$router.push('/dash/postCreator/edit');
                        else this.$router.push('/dash/postCreator/update');
                       
                    break;
                    case 'draft':
                        if (this.event.originalPost.page && this.event.originalPost.page[0] && !this.isPgDraft) {
                            // Nouveau brouillon (MongoDB) : ouvrir en mode 'edit'
                            const multipages = this.event.originalPost.page[0].posts_multipages || []
                            const draftPosts = multipages.length > 0
                                ? multipages.map(pm => ({
                                    _id: pm._id,
                                    id: pm._id,
                                    bot: pm.bot,
                                    page: pm.page,
                                    postId: pm.postId || null,
                                    status: pm.status,
                                }))
                                : [{
                                    _id: this.event.originalPost.id,
                                    id: this.event.originalPost.id,
                                    bot: this.event.originalPost._bots[0].id,
                                    page: this.event.originalPost._bots[0].page.id,
                                    postId: this.event.originalPost.page[0].post_number,
                                    status: this.event.originalPost.page[0].status,
                                }]
                            this.$store.commit('postCreator/setDataForEditPost', {
                                draft: this.event.draft,
                                posts: draftPosts,
                                post: this.event.originalPost
                            });
                            this.$router.push('/dash/postCreator/edit');
                        } else {
                            // Ancien brouillon PG : comportement inchangé
                            this.$store.commit('postCreator/setDataForDraft', {
                                data: this.event.draft,
                                id : this.event.originalPost.id
                            });
                            this.$router.push('/dash/postCreator/draft');
                        }
                    break;
                }
                                 
            },                                                                                      

            duplicatePost(excludeNews = false) {
                if (!this.canUseActions) return;
                let pages
                // posts_multipages is the reliable source for "all pages this draft/post spans"
                // (same source editPost()'s 'draft' case uses, index.vue:509) — draft.pages isn't
                // trustworthy for that, which is why only some drafts hit this.
                if (this.event.status != 'standby' && this.event.originalPost.page[0].posts_multipages && this.event.originalPost.page[0].posts_multipages.length) {
                    pages = this.event.originalPost.page[0].posts_multipages.map(post => post.page)
                }else if (this.event.originalStatus == 'draft' && this.event.draft.pages && this.event.draft.pages.length) {
                    pages = this.event.draft.pages
                }else{
                    pages = [this.event.originalPost._bots[0].page.id]
                }
     
                this.$store.commit('postCreator/setDataForDuplicatePost', {
                    draft: this.event.draft,
                    pages,
                    excludeNews
                });
                this.$router.push('/dash/postCreator/duplicate');
            },

            deletePost() {
                if (!this.canUseActions) return;

                EventBus.$emit("showModal",
                    this.$t('dash.button.delete.post'),
                    this.$t('dash.posts.drawer.delete-confirm'),
                    this.$t('dash.button.delete'),
                    this.$t('dash.button.cancel'),
                    ()=>{
                        this.$emit('deletePost')
                    }
                );
               
            },

            clickOption(contextMenuId, nameOption, event) {
           
                switch (nameOption) {
                    case 'copyLink':
                        const baseUrl = window.location.origin;
                        const paramsLink = {
                            post_id: this.event.originalPost.id,
                            page_id: this.event.page.id,
                            bot_id: this.event.originalPost._bots[0].id,
                            is_draft: this.officialStatus === 'draft'
                        };

                        const queryString = new URLSearchParams(paramsLink).toString();
                        // const link = `${baseUrl}/#/dash/posts2?${queryString}`;
                        let eventOldVersion = !(
                            (this.event.originalStatus == 'draft' && (this.event.originalPost.draft?.data?.saveAllFormData || this.event.draft?.saveAllFormData)) ||
                            (this.event.originalStatus != 'draft' && this.event.originalPost.page[0].draft && this.event.originalPost.page[0].draft.includes('saveAllFormData'))
                        )
                        const link = `${baseUrl}/${eventOldVersion ? '' : '#/dash/posts2'}?${queryString}${eventOldVersion ? '&show_post=true&no_redirection=true' : ''}`;

                        navigator.clipboard.writeText(link).then(() => {
                            this.$vs.notify({
                                title: this.$t('dash.posts.success'),
                                text: this.$t('dash.settings.user.viewer_url.copy'),
                                color:'success'
                            })
                           
                        }, (err) => {
                            console.error('Error copying text: ', err);
                        });
                        break;
                    case 'showPost':
                        this.showOriginalPost()
                        break;
                    default:
                        break;
                }
            },

            async showOriginalPost(){
                let url
                switch(this.event.page.network){
                    case 'facebook':
                        url = `https://www.facebook.com/${this.event.originalPost.page[0].post_number}`
                    break
                    case 'twitter': 
                        const username = this.event.originalPost._bots.find(b => b.uid == this.event.originalPost.page[0].id).page.name
                        url = `https://www.twitter.com/${username}/status/${this.event.originalPost.page[0].post_number}`
                    break
                    case 'linkedin': 
                        if (this.event.originalPost.page[0].post_number_bis) {
                            url = `https://www.linkedin.com/feed/update/${this.event.originalPost.page[0].post_number_bis}`
                        } else {
                            const res = await this.getLinkedinPost(this.event.originalPost._bots[0].page.id, this.event.originalPost.page[0].post_number)
                            const { success, post } = res.body

                            if(success && post && post.activity)
                                url = `https://www.linkedin.com/feed/update/${post.activity}`
                            else if(success && post && post.id)
                                url = `https://www.linkedin.com/feed/update/${post.id}`
                        }
                    break
                    case 'pinterest':
                        url = `https://www.pinterest.fr/pin/${this.event.originalPost.page[0].post_number}`
                    break
                    case 'google':
                        if(this.event.originalPost.page[0].post_number_bis)
                            url = this.event.originalPost.page[0].post_number_bis
                        else {
                            const res = await this.getGooglePost(this.event.originalPost._bots[0].page.id, this.event.originalPost.page[0].post_number)
                            const { success, searchUrl } = res.body
                            if(success && searchUrl) url = searchUrl
                            else url = `https://www.google.com/search?q=${this.event.originalPost.page[0].post_number}`
                        }
                    break
                    case 'youtube':
                        url = `https://www.youtube.com/shorts/${this.event.originalPost.page[0].post_number}`
                        //redirection vers la vidéo si pas format reel par youtube
                    break
                    case 'threads':
                        const threadsUsername = this.event.originalPost._bots.find(b => b.uid == this.event.originalPost.page[0].id).page.name
                        url = `https://www.threads.net/@${threadsUsername}`
                    break
                    case 'bluesky':
                        const blueskyUsername = this.event.originalPost._bots.find(b => b.uid == this.event.originalPost.page[0].id).page.name
                        url = `https://bsky.app/profile/${blueskyUsername}/post/${this.event.originalPost.page[0].post_number.split('/').pop()}`
                    break
                    default:
                }

               if (url) Popup.open(url, '', 900, 700)
            },

            formatDateRelative(d) {
                if (typeof d !== "object") d = new Date(d)
                const now = new Date()
                const locale = this.$i18n.locale || 'fr-FR'
                const hhmm = d.getHours() + ':' + (d.getMinutes() < 10 ? '0' : '') + d.getMinutes()
                const sameDay = d.getDate() === now.getDate() && d.getMonth() === now.getMonth() && d.getFullYear() === now.getFullYear()
                const yesterday = new Date(now); yesterday.setDate(now.getDate() - 1)
                const isYesterday = d.getDate() === yesterday.getDate() && d.getMonth() === yesterday.getMonth() && d.getFullYear() === yesterday.getFullYear()
                if (sameDay) return this.$t('dash.posts.drawer.today-at') + ' ' + hhmm
                if (isYesterday) return this.$t('dash.posts.drawer.yesterday-at') + ' ' + hhmm
                const dateStr = d.toLocaleDateString(locale, { day: 'numeric', month: 'short', year: 'numeric' })
                return this.$t('dash.posts.drawer.date-prefix') + ' ' + dateStr + ' ' + this.$t('dash.posts.drawer.date-at') + ' ' + hhmm
            },

            dateFormat(dateFormat) {
                return this.formatDateRelative(dateFormat)
            },

            buildComment() {
        
                if (this.event.originalPost.page.length && this.event.originalPost.page[0].internal_notes && this.event.originalPost.page[0].internal_notes.length) {
                    this.comments = this.event.originalPost.page[0].internal_notes.map((comment) => ({
                        ...comment,
                        dateFormat : this.dateFormat(comment.date),
                        avatar:  this.usersSortByEmail[comment.email] ? this.usersSortByEmail[comment.email].avatar : null,
                        ...(comment.email == this.currentUser.email ? {name : this.$t('dash.posts.drawer.you')} : {})
                    })).reverse()
                }else{
                    this.comments = []
                }
            },

            buildLogs() {
                console.log("buildLogs")
                const dateFormatPost = (dateLog) => {
                    if (Date.now() - new Date(dateLog).getTime() < 60000) {
                        return this.$t('dash.posts.drawer.just-now')
                    }
                    return this.formatDateRelative(dateLog)
                }

                
                if (this.event.originalPost && this.event.originalPost.page && this.event.originalPost.page[0] && this.event.originalPost.page[0].log) {
                    console.log("buildLogs", this.event.originalPost.page[0].log)
                    this.logs = this.event.originalPost.page[0].log.reduce((acc, log) => {
                                           
                        try {
                            if (typeof log == 'string') log = JSON.parse(log)
                            console.log("log", log)
                            if (!('title' in log) || !('created_at' in log) || !('user' in log)) return acc
                        
                            if (log.title.startsWith('dash.')) {
                                const parts = log.title.split('|')
                                const key = parts[0]
                                const params = parts[1] ? JSON.parse(parts[1]) : {}
                                log.title = this.$t(key, params)
                            }

                            if (log.user.lastname && log.user.firstname) {
                                log.title = log.title.replace('$name', `<span class="name">${log.user.lastname} ${log.user.firstname}</span>`)
                            }else {
                                log.title = log.title.replace('$name', `<span class="email">${log.user.email}</span>`)
                            }
                        

                            acc.push({
                                ...log,
                                content: log.content ?  marked.parse(log.content) : '',
                                dateFormat: dateFormatPost(log.created_at)
                            });
                        } catch (error) {
                            console.error("Error parsing log", error)
                        }
                        
                        
                        return acc;
                    }, []).sort((a, b) => new Date(b.created_at) - new Date(a.created_at)); // Trier par date décroissante
                }else{
                    console.log('aucunes logs disponibles')
                }
            },

            handleScroll(event) {
                this.expandedSectionNav = true
            },

            parsedLabelIcon(icon) {
                return parseLabelIcon(icon)
            },

            // Only updates the local chip display while the picker is open — the
            // actual save (and the multi-page prompt) happens once on close, in
            // closeLabelPicker(), so selecting several labels in a row doesn't fire
            // a request (and a confirmation popup) per click.
            onLabelsUpdate(newLabelIds) {
                if (this.event.originalPost.page && this.event.originalPost.page[0]) {
                    this.$set(this.event.originalPost.page[0], 'labels', newLabelIds)
                }
            },

            toggleLabelPicker() {
                if (this.labelPickerOpen) {
                    this.closeLabelPicker()
                } else {
                    this.labelPickerSnapshot = [...this.postLabelIds]
                    this.labelPickerOpen = true
                }
            },

            closeLabelPicker() {
                // Guards against a double-fire on the same click: clicking the backdrop
                // triggers both its own @click and LabelPicker's internal click-outside
                // (both reach this method) — the second call must be a no-op.
                if (!this.labelPickerOpen) return
                this.labelPickerOpen = false
                const before = JSON.stringify(this.labelPickerSnapshot.slice().sort())
                const after = JSON.stringify(this.postLabelIds.slice().sort())
                if (before !== after) this.persistLabels()
            },

            async persistLabels(all = null) {
                if (all == null) {
                    if (this.isPostsMultipaged(this.event.originalPost)) {
                        EventBus.$emit("showModal",
                            this.$t('dash.posts.multi-pages.add_label.title'),
                            this.$t('dash.posts.multi-pages.add_label.body'),
                            this.$t('dash.posts.drawer.all-posts'),
                            this.$t('dash.posts.drawer.this-post-only'),
                            () => { this.persistLabels(true) },
                            () => { this.persistLabels(false) },
                        )
                        return
                    } else {
                        all = false
                    }
                }

                const postId = this.event.originalPost.id
                const labels = this.postLabelIds
                await this.setPostLabels({ id: postId, labels, all })
                this.newLog(postId, JSON.stringify(this.generateLog({ title: 'dash.posts.log.labels-updated' })), all)
                EventBus.$emit('planner/refresh', 1000)
            },
        },

        watch: {
            post: {
                immediate: true,
                handler(newValue, oldValue) {
                    this.buildLogs()
                    this.buildComment()
                }
            },
            ["event.draft.saveAllFormData"]: {
                handler() {
                    this.setFormData()
                },
                immediate: true
            },
        },
        

        computed: {
            isNativeFacebookStory() {
                return this.event.page.network === 'facebook' && !this.event.originalPost?.page?.[0]?.shared_to_facebook
            },
            officialStatus() {
                return !this.event.originalPost.page || !this.event.originalPost.page.length
                            ? 'standby'
                            : ['removed', null, 'scheduled', 'posted', 'pending', 'failed', 'failed', 'draft', "processing"][this.event.originalPost.page[0].status + 1] //+1 pour inclure removed (removed = -1) ; status 5 = erreur auto-post retentable, mappé sur "failed"

            },
            isPgDraft() {
                // isPgDraft (flag backend) n'est pas fiable — format d'id à la place, comme Posts2.vue:97.
                if (!this.event.originalPost) return false
                return !/^[0-9a-f]{24}$/i.test(this.event.originalPost.id || '')
            },
            postLabelIds() {
                return (this.event.originalPost && this.event.originalPost.page && this.event.originalPost.page[0] && this.event.originalPost.page[0].labels) || []
            },
            resolvedLabels() {
                const allLabels = this.$store.getters['labels/getLabels']
                return this.postLabelIds.map(id => allLabels[id]).filter(Boolean)
            },
            allPages() {
                return this.$store.getters['selectPage/selectPageAllPages'];
            },
            usersSortByEmail() {
                return Object.fromEntries(
                    Object.entries(this.$store.getters['users/getUsers']).map(([key, value]) => [value.email, value])
                );
            },
            currentUser() {
                return this.$store.getters['users/getCurrentUser']
            },

            validationStatus() {
                //return null if not option actived or current user not affected
                //return false if post not validated
                //return true if post validated
                if (this.officialStatus == "failed") return null

                if (
                    ['draft', 'scheduled', 'processing'].includes(this.officialStatus) && 
                    this.event.originalPost.page[0].affectedTo &&
                    this.event.originalPost.page[0].affectedTo.optionValidation &&
                    this.event.originalPost.page[0].affectedTo.optionValidation !== "false" &&
                    (
                        (this.event.originalPost.page[0].affectedTo.user && this.event.originalPost.page[0].affectedTo.user.id  == this.currentUser.id) ||
                        (this.event.originalPost.page[0].affectedTo.users && this.event.originalPost.page[0].affectedTo.users.some(user => user.id == this.currentUser.id))
                    )

                ) {
                    // option validation actived
                    return ("wait_validation" in this.event.originalPost.page[0] && this.event.originalPost.page[0].wait_validation !== null && this.event.originalPost.page[0].wait_validation !== 'null')

                }


                return null

            },

            canUseActions() {
                return !this.isRefreshingMusic && !this.hasPendingMediaExport;
            },

            isProcessing() {
                return this.event.originalStatus === 'processing' || this.event.originalPost.page[0]?.posts_multipages?.some((posts_mp) => posts_mp.status === 7);
            },

            // True while a video/photo re-export this exact post depends on is still being
            // prepared client-side (see mediaExportJobs.js's isPostLocked - matches by page+post id
            // against every pendingPublish's own `posts`, set in PostCreator.vue's
            // sendPostAllPostDeferred). Checks the main page/post plus every posts_multipages entry
            // (same fields isProcessing already reads above) since a multi-page post can depend on
            // several pending exports at once.
            hasPendingMediaExport() {
                const page0 = this.event.originalPost.page && this.event.originalPost.page[0]
                if (!page0) return false
                const isLocked = this.$store.getters['mediaExportJobs/isPostLocked']
                if (isLocked(this.event.originalPost.id, page0.id)) return true
                return (page0.posts_multipages || []).some((pm) => isLocked(pm._id, pm.page))
            },

            isConvertedToV2() {
                if (this.event.originalStatus === 'draft') {
                    if (this.isPgDraft) {
                        return !this.event.originalPost.draft?.data?.saveAllFormData
                    }
                    return !this.event.draft?.saveAllFormData
                }
                return !(this.event.originalPost.page[0]?.draft && this.event.originalPost.page[0].draft.includes('saveAllFormData'))
            },

            isPostedPost() {
                const p = this.event && this.event.originalPost
                if (!p) return false
                if (p.status === 'posted') return true
                return p.page && p.page[0] && p.page[0].status === 2
            },

            optionsContextMenu() {
                const options = [{label: this.$t('dash.posts.drawer.copy-link'), name : 'copyLink'}]

                if (
                    this.event.originalStatus == 'posted' &&
                    ['facebook', 'twitter', 'linkedin', 'pinterest', 'google', 'youtube', 'threads', 'bluesky'].includes(this.event.page.network) &&
                    !(this.event.page.network ===  'linkedin' && !/^[0-9]+$/.test(this.event.originalPost._bots[0].page.network_id)) &&
                    !(this.event.originalPost.page && this.event.originalPost.page[0] && this.event.originalPost.page[0].story)

                ) {
                    options.push({label: this.$t('dash.posts.drawer.view-post'), name : 'showPost'})
                }

                return options
            }

        },

        beforeDestroy() {
            this.$refs.scrollContainer.removeEventListener('wheel', this.handleScroll);
        },
        
    }
</script>

